import React from 'react';
import classNames from 'classnames';

import { getSignature } from '../../../utils/images';
import { DOMAIN_LANGUAGE, DE } from '../../../constants/browser';

import styles from './index.module.scss';

export const SIGNATURE_SRC = getSignature(DOMAIN_LANGUAGE) || getSignature(DE);

export default ({ className }) => (
  <img
    className={classNames(styles['signature'], className)}
    src={SIGNATURE_SRC}
    alt="signature-pic"
  />
);
